import { render, staticRenderFns } from "./TalabatBadge.vue?vue&type=template&id=57e6ab4f&scoped=true&"
import script from "./TalabatBadge.vue?vue&type=script&lang=js&"
export * from "./TalabatBadge.vue?vue&type=script&lang=js&"
import style0 from "./TalabatBadge.vue?vue&type=style&index=0&id=57e6ab4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e6ab4f",
  null
  
)

export default component.exports